import { Typography } from "@mui/material";
import { useState, useEffect } from "react";
import CommentBox from "../CommentBox/CommentBox";
import "./CommentsList.css";

function CommentsList({ comments, onSelectComment }) {
    const [numberReadComments, setNumberReadComments] = useState(0);

    useEffect(() => {
        setNumberReadComments(countUnreadComments());
    }, [comments]);

    const handleSelectedComment = (comment, user) => {
        comment.username = user;
        onSelectComment(comment);
    }

    const countUnreadComments = () => {
        return comments.filter(comment => !comment.is_viewed).length;
    }

    return (
        <div className="navigation">
            <Typography variant="h5" marginLeft="1rem" marginTop="1rem">Boite de réception ({numberReadComments})</Typography>
            <ul>
                {comments.length > 0 &&
                    comments.map((comment, index) => (
                        <li key={index}>
                            <CommentBox
                                id={comment.id}
                                user_id={comment.user_id}
                                is_viewed={comment.is_viewed}
                                onClick={(_, user) => handleSelectedComment(comment, user)}
                                date={comment.date}
                                subject={comment.subject}
                                tags={comment.tags}
                            />
                        </li>
                    ))
                }
            </ul>
        </div>
    );
}

export default CommentsList;
